import Reveal from "@/components/Reveal";
import { IMAGES, CHAPTERS } from "@/data/site";

export default function About() {
    return (
        <section id="about" data-testid="about-section" className="py-16 md:py-24 lg:py-32 bg-[#FFFDF9]">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
                    <div className="lg:col-span-5 relative">
                        <Reveal>
                            <div className="overflow-hidden rounded-[2rem] border-8 border-white shadow-[0_24px_60px_rgba(61,35,24,0.18)] -rotate-2">
                                <img src={IMAGES.realAnnabell} alt="Annabell, the baker behind Annabells Cupcakes and More" data-testid="about-photo" className="h-[420px] sm:h-[520px] w-full object-cover object-[center_35%]" />
                            </div>
                            <div className="absolute -bottom-6 -right-4 rotate-3 rounded-2xl bg-[#3D2318] px-6 py-4 shadow-xl">
                                <p className="font-script text-2xl text-[#F8D7E3]">Homemade · Fresh</p>
                                <p className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] font-semibold">Made With Love</p>
                            </div>
                        </Reveal>
                    </div>

                    <div className="lg:col-span-7">
                        <Reveal>
                            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#C59B27]" data-testid="about-eyebrow">
                                About Annabell
                            </p>
                            <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#3D2318]">
                                Made <span className="font-script font-medium text-[#C95B7D] text-4xl sm:text-5xl lg:text-6xl align-middle">With Love</span>
                            </h2>
                            <p className="mt-5 max-w-2xl text-base sm:text-lg text-[#6B4A3E] leading-relaxed font-light">
                                Welcome to Annabells Cupcakes and More! Annabell loves taking a simple idea and turning it
                                into something delicious and memorable.
                            </p>
                        </Reveal>

                        <div className="mt-12 space-y-10">
                            {CHAPTERS.map((c, i) => (
                                <Reveal key={c.number} delay={i * 0.1}>
                                    <div className="flex gap-6" data-testid={`about-chapter-${c.number}`}>
                                        <span className="font-display text-4xl sm:text-5xl font-bold text-[#F8D7E3] select-none leading-none">
                                            {c.number}
                                        </span>
                                        <div className="border-l border-[#F2E1E6] pl-6">
                                            <h3 className="font-display text-xl sm:text-2xl font-semibold text-[#3D2318]">{c.heading}</h3>
                                            <p className="mt-2 text-sm sm:text-base text-[#6B4A3E] leading-relaxed">{c.body}</p>
                                        </div>
                                    </div>
                                </Reveal>
                            ))}
                        </div>

                        <Reveal delay={0.2}>
                            <a
                                href="#gallery"
                                data-testid="about-gallery-button"
                                className="mt-10 inline-flex items-center gap-2 text-sm font-semibold text-[#C95B7D] hover:text-[#3D2318] transition-colors duration-300"
                            >
                                See Our Creations
                                <span aria-hidden="true">→</span>
                            </a>
                        </Reveal>
                    </div>
                </div>
            </div>
        </section>
    );
}
